module.exports = __webpack_public_path__ + "static/img/smile.4f0a5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/emoji/smile.png
// module id = OhEK
// module chunks = 0